var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 19.5,
    fill: "#000",
    stroke: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#fff",
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.982c2.937 0 3.285.011 4.445.064a6.07 6.07 0 0 1 2.042.379 3.4 3.4 0 0 1 1.265.823 3.4 3.4 0 0 1 .823 1.265 6.07 6.07 0 0 1 .379 2.042c.053 1.16.064 1.508.064 4.445 0 2.937-.011 3.285-.064 4.445a6.07 6.07 0 0 1-.379 2.042 3.644 3.644 0 0 1-2.088 2.088 6.07 6.07 0 0 1-2.042.379c-1.16.053-1.508.064-4.445.064-2.937 0-3.285-.011-4.445-.064a6.07 6.07 0 0 1-2.042-.379 3.4 3.4 0 0 1-1.265-.823 3.4 3.4 0 0 1-.823-1.265 6.07 6.07 0 0 1-.379-2.042c-.053-1.16-.064-1.508-.064-4.445 0-2.937.011-3.285.064-4.445a6.07 6.07 0 0 1 .379-2.042 3.4 3.4 0 0 1 .823-1.265 3.4 3.4 0 0 1 1.265-.823 6.07 6.07 0 0 1 2.042-.379c1.16-.053 1.508-.064 4.445-.064ZM20 9c-2.987 0-3.362.013-4.535.066a8.108 8.108 0 0 0-2.67.511A5.625 5.625 0 0 0 9.577 12.8a8.108 8.108 0 0 0-.511 2.67C9.013 16.638 9 17.013 9 20s.013 3.362.066 4.535c.019.912.192 1.815.511 2.67a5.625 5.625 0 0 0 3.223 3.218c.855.32 1.758.492 2.67.511 1.168.053 1.543.066 4.53.066s3.362-.013 4.535-.066a8.109 8.109 0 0 0 2.67-.511 5.626 5.626 0 0 0 3.218-3.223c.32-.855.492-1.758.511-2.67.053-1.168.066-1.543.066-4.53s-.013-3.362-.066-4.535a8.109 8.109 0 0 0-.511-2.67A5.626 5.626 0 0 0 27.2 9.577a8.108 8.108 0 0 0-2.67-.511C23.362 9.013 22.987 9 20 9Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.351a5.649 5.649 0 1 0 0 11.298 5.649 5.649 0 0 0 0-11.298Zm0 9.316a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334ZM25.872 15.448a1.32 1.32 0 1 0 0-2.64 1.32 1.32 0 0 0 0 2.64Z",
    fill: "#000"
  })));
};
export default SvgInstagram;